// Fragment "messages" — the client's side of the two-way thread with the practice:
// public/ClientConversation.jsx, hosted by the Messages section of public/ClientPortal.jsx.
// The PUBLIC CONTACT FORM does not read this fragment: its copy is practitioner-editable
// Site Content (`contact.*` in lib/content.js), not product chrome.
// Merged in ./index.js.
export default {
  fr: {
    "portal.messages": "Messages",
    "portal.messages.empty": "Aucun message pour l'instant — écrivez à la praticienne ci-dessous.",
    "portal.messages.you": "Vous",
    // Used only when the practice record carries neither tagline nor name; the portal
    // passes the same `practiceName` it prints in its own header.
    "portal.messages.practice": "La praticienne",
    "portal.messages.placeholder": "Écrivez votre message…",
    "portal.messages.send": "Envoyer",
    "portal.messages.sending": "Envoi en cours…",
    "portal.messages.charCount": "{n}/{max}",
    "portal.messages.sendHint": "Ctrl/⌘ + Entrée pour envoyer",
    "portal.messages.loading": "Chargement des messages…",
    "portal.messages.loadFailed": "Impossible de charger vos messages. Réessayez dans un instant.",
    "portal.messages.sendFailed": "Votre message n'a pas pu être envoyé. Réessayez svp.",
    "portal.messages.rateLimited": "Vous avez envoyé plusieurs messages coup sur coup. Patientez quelques minutes.",
    "portal.messages.older": "Voir les messages plus anciens",
  },
  en: {
    "portal.messages": "Messages",
    "portal.messages.empty": "No messages yet — write to the practice below.",
    "portal.messages.you": "You",
    "portal.messages.practice": "The practice",
    "portal.messages.placeholder": "Write your message…",
    "portal.messages.send": "Send",
    "portal.messages.sending": "Sending…",
    "portal.messages.charCount": "{n}/{max}",
    "portal.messages.sendHint": "Ctrl/⌘ + Enter to send",
    "portal.messages.loading": "Loading your messages…",
    "portal.messages.loadFailed": "Your messages could not be loaded. Try again in a moment.",
    "portal.messages.sendFailed": "Your message could not be sent. Please try again.",
    "portal.messages.rateLimited": "You have sent several messages in a row. Please wait a few minutes.",
    "portal.messages.older": "Show older messages",
  },
  es: {
    "portal.messages": "Mensajes",
    "portal.messages.empty": "Aún no hay mensajes — escribe a la consulta aquí abajo.",
    "portal.messages.you": "Tú",
    "portal.messages.practice": "La consulta",
    "portal.messages.placeholder": "Escribe tu mensaje…",
    "portal.messages.send": "Enviar",
    "portal.messages.sending": "Enviando…",
    "portal.messages.charCount": "{n}/{max}",
    "portal.messages.sendHint": "Ctrl/⌘ + Intro para enviar",
    "portal.messages.loading": "Cargando tus mensajes…",
    "portal.messages.loadFailed": "No se pudieron cargar tus mensajes. Inténtalo de nuevo en un momento.",
    "portal.messages.sendFailed": "No se pudo enviar tu mensaje. Inténtalo de nuevo.",
    "portal.messages.rateLimited": "Has enviado varios mensajes seguidos. Espera unos minutos.",
    "portal.messages.older": "Ver mensajes anteriores",
  },
};
